.scrollerInner {
    -webkit-overflow-scrolling: touch;
    scrollbar-width: none;

    &::-webkit-scrollbar {
        display: none;
    }
}

.scrollButtonLeft {
    background: linear-gradient(to right, lightgray, transparent);
}

.scrollButtonRight {
    background: linear-gradient(to left, lightgray, transparent);
}
